import { apiService } from '@/api/apiConfig';
import {
  ProfileCreationData,
  ProfileCreationResponse,
  ProfileUpdateData,
  ProfileUpdateResponse,
  UserProfileResponse
} from '@/services/types/user.types';
// import { AuthApiService } from '@/services/authApi.service';

const handleUserError = (error: any): Error => {
  return error instanceof Error ? error : new Error('User operation failed');
};

interface ApiService {
  request: <T>(config: any) => Promise<T>;
}

const createUserService = (apiServiceInstance: ApiService = apiService) => ({
  createProfile: async (profileData: ProfileCreationData): Promise<ProfileCreationResponse> => {
    try {
      console.log('USING userService.createProfile');
      // if there's a profile picture, handle it with FormData
      if (profileData.profilePicture) {
        const formData = new FormData();
        formData.append('profilePicture', profileData.profilePicture);

        (Object.keys(profileData) as Array<keyof ProfileCreationData>).forEach((key) => {
          if (key !== 'profilePicture' && profileData[key]) {
            formData.append(key, String(profileData[key]));
          }
        });

        console.log('asd formData:', formData);

        return await apiServiceInstance.request<ProfileCreationResponse>({
          method: 'POST',
          url: '/auth/create-profile',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      // if no profile picture, send JSON data
      return await apiServiceInstance.request<ProfileCreationResponse>({
        method: 'POST',
        url: '/auth/create-profile',
        data: profileData
      });
    } catch (error) {
      throw handleUserError(error);
    }
  },

  updateProfile: async (profileData: ProfileUpdateData): Promise<ProfileUpdateResponse> => {
    try {
      if (profileData.profilePicture) {
        const formData = new FormData();
        formData.append('profilePicture', profileData.profilePicture);

        (Object.keys(profileData) as Array<keyof ProfileUpdateData>).forEach((key) => {
          if (key !== 'profilePicture' && profileData[key] !== undefined && profileData[key] !== null) {
            formData.append(key, String(profileData[key]));
          }
        });

        return await apiServiceInstance.request<ProfileUpdateResponse>({
          method: 'POST',
          url: '/profile/edit-profile',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      return await apiServiceInstance.request<ProfileUpdateResponse>({
        method: 'POST',
        url: '/profile/edit-profile',
        data: profileData
      });
    } catch (error) {
      throw handleUserError(error);
    }
  },

  deleteProfile: async (firebaseId: string): Promise<void> => {
    try {
      return await apiServiceInstance.request<void>({
        method: 'DELETE',
        url: `/profile/${firebaseId}`
      });
    } catch (error) {
      throw handleUserError(error);
    }
  },

  getUserProfile: async (userId: string): Promise<UserProfileResponse> => {
    try {
      return await apiServiceInstance.request<UserProfileResponse>({
        method: 'GET',
        url: `/profile/${userId}`
      });
    } catch (error) {
      throw handleUserError(error);
    }
  },

  getUserProfileByClerkId: async (clerkId: string): Promise<UserProfileResponse> => {
    try {
      return await apiServiceInstance.request<UserProfileResponse>({
        method: 'GET',
        url: `/profile/clerk/${clerkId}`
      });
    } catch (error) {
      throw handleUserError(error);
    }
  },

  unregister: async (): Promise<void> => {
    try {
      return await apiServiceInstance.request<void>({
        method: 'POST',
        url: `/user/unregister`
      });
    } catch (error) {
      throw handleUserError(error);
    }
  },

  reactivateUser: async (): Promise<void> => {
    try {
      return await apiServiceInstance.request<void>({
        method: 'POST',
        url: `/user/reactivate`
      });
    } catch (error) {
      throw handleUserError(error);
    }
  }
});

// Export the service function for backward compatibility
export const userService = createUserService();

// Export the factory function for components that need authenticated requests
export { createUserService };
